import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import ErrorModal from '../ErrorModal';
import MutationRequest from '../MutationRequest';

export const RATE_MYAPP = gql`
  mutation rateMyApp(
    $appIdentifier: String!
    $rate: Int!
    $comment: String!
    $title: String!
  ) {
    app {
      rateApp(
        inputType: {
          appIdentifier: $appIdentifier
          rate: $rate
          comment: $comment
          title: $title
        }
      ) {
        id
      }
    }
  }
`;

const rateAppRequest = ({
  appIdentifier,
  rate,
  title,
  comment,
  onError,
  onSuccessResult,
}) => (
  <Mutation mutation={RATE_MYAPP}>
    {(rateMyApp, { loading, error, data }) => {
      const variables = {
        appIdentifier,
        rate,
        comment,
        title,
      };

      if (error) {
        return <ErrorModal error={error} onError={onError} />;
      }
      if (data) {
        onSuccessResult(data.app.rateApp);
      }

      return (
        <MutationRequest
          isLoading={loading}
          mutation={rateMyApp}
          variables={variables}
        />
      );
    }}
  </Mutation>
);

rateAppRequest.propTypes = {
  appIdentifier: PropTypes.string.isRequired,
  comment: PropTypes.string.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
  rate: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
};

rateAppRequest.defaultProps = {};

export default rateAppRequest;
